/* @flow weak */

'use strict';

const Reflux = require('reflux');

const ProductActions = Reflux.createActions([
  'load'
]);

module.exports = ProductActions;


// WEBPACK FOOTER //
// ./src/base/scripts/actions/ProductActions.jsx